import _ from 'lodash'
import LocationBaseController from '../common/location.base.controller'

class LocationallController extends LocationBaseController {
  /*@ngInject*/
  constructor(Auth, $state, User, Modal, LocationService, $translate, $stateParams, $scope, $location, DataCounter) {

    super(Auth, $state, User, LocationService, Modal, $translate, $stateParams, $location)

    this.id = 'location.all'
    this.loading = false //true
    this.locations = []
    this.page = 1
    this.total = 0
    this.pageLimit = 10
    this.maxPages = 10
    this.hasACL = {}
    this.$location = $location;
    this.branch = User.getUser().branchId;
    this.DataCounter = DataCounter;
    this.customerId = User.getUser().customerUser ? User.getUser().customerId : null;
    this.loggedInUserId = User.getUser().id;
    this.User = User;

    this.icon = {
      'REGULAR': 'regular.png',
      'ATM': 'atm.png',
      'BANK': 'bank.png',
      'NO_SHIP_NO_GO': 'nsng.png',
      'INTERNAL': 'internal.png',
      'TRUCK': 'truck.png',
      'TANKER': 'tanker.png',
      'WINDOW': 'window.png',
      'ON_CALL': 'oncall.png',
      'CARRIER': 'carrier.png',
      'LOCKER': 'locker.png',
      'VAULT': 'vault.png',
      'DELIVERY': 'delivery.png'
    }
    this.searchObj = {
      type: '',
      text: '',
      status: 'active'
    };

    this.locationStatus = [
      {
        label: $translate.instant('location_types.All'),
        value: null,
      },
      {
        label: $translate.instant('common.active'),
        value: 'active'
      },
      {
        label: $translate.instant('common.inactive'),
        value: 'inactive'
      },
      {
        label: $translate.instant('location.pending_changes'),
        value: 'pending_changes'
      }]

    this.locationTypeList = ['', 'DELIVERY', 'ATM', 'LOCKER', 'Regular', 'Bank', 'ON_CALL', 'NO_SHIP_NO_GO', 'Internal', 'Truck', 'Tanker', 'Carrier', 'Window', 'VAULT']
    this.locationTypes = this.locationTypeList.map((list) => {
      if (list == '') {
        return {
          value: '',
          label: $translate.instant('location_types.All')
        };
      }
      return {
        value: list,
        label: $translate.instant('location_types.' + list)
      };
    });

    this.reportPrefix = 'Locations';
    this.isExporting = false;
    this.locationUpdateHistory = {};
    this.locationHistory = {};
    this.pendingLocationChanges = {};
    this.pagination = {
      page: 1,
      total: 0,
      pageLimit: 10,
      maxPages: 10
    }
    this.locationIds = [];
    this.customerContractData = '';
    this.selectedLocations = [];
    this.filterByValue = null;
    this.model.filterByAllBranch = false;
  }

  loadImage = function (image) {
    let imgURL = this.icon[image]
    return require('../../../assets/images/' + imgURL);
  }

  $onInit() {
    this.customerContractData = this.DataCounter.getData();

    let pageId = this.$stateParams.page;
    if (pageId > 0) {
      this.page = pageId
    }
    this.loadData()
  }

  edit(location) {
    this.$state.go('location.edit', ({
      id: location.id
    }))
  }

  delete(location) {
    if (this.allowOnlyOnce) return;
    this.allowOnlyOnce = true;
    this.Modal.confirm({
      header: this.$translate.instant('common.confirm_delete_title'),
      message: this.$translate.instant('common.confirm_delete_message') + ` <strong>${location.id}</strong>?`,
      callback: (({
        modal,
        $scope
      }) => {
        $scope.loading = true;
        this.Service.remove(location.id, this.branch)
          .then((data) => {
            this.allowOnlyOnce = false;
            modal.close();
            this.refresh();
          })
          .catch((err) => {
            $scope.isLoading = false;
            $scope.loading = false;
            this.allowOnlyOnce = false;
            if (err && err.data && err.data.message) {
              return this.Modal.errorModal('location.reference_error');
            }
          })
      }),
      negative: (({
        modal,
      }) => {
        this.allowOnlyOnce = false;
        modal.close();
      }),
      type: 'danger'
    })
  }

  refresh() {
    this.loadData()
  }

  pageChange() {
    let newUrl = (window.location.pathname).replace('/' + this.$stateParams.page, '/' + this.page)
    this.$stateParams.page = this.page;
    this.$location.path(newUrl)
    this.loadData();
  }

  loadData() {
    const searchObj = this.generateSearchObj();
    this.loading = true;
    this.Service.getAllLocation(searchObj, (this.page - 1) * this.pageLimit, this.pageLimit)
      .then((data) => {
        this.total = data.total;
        this.loading = false;
        this.locations = data.results;
        this.totalActiveLocation = data.totalActive;
        this.totalInActiveLocation = data.totalInActive;
        this.maintainDriveDistance = data.maintainDriveDistance;

        this.selectedLocations.forEach((selectedLoc) => {
          this.locations.forEach((loc) => {
            if (selectedLoc.locationId === loc.id) {
              loc.isSelected = true;
            }
          })
        })

        setTimeout(() => {
          this.resetRedirectionalData();
        }, 5000)
      })
      .catch((err) => {
        this.loading = false
        this.error = err.message
        if (err && err.data && err.data.message) {
          this.Modal.errorModal(err.data.message);
        }
      })
  }

  filterByBranch(value) {
    this.page = 1;
    this.filterByValue = this.filterByValue === value ? undefined : value;
    this.model.filterByAllBranch = this.filterByValue ? true : false;
    this.loadData();
  }

  generateSearchObj() {
    let obj = {
      queryJSON: {
        rules: [],
        getPendingChanges: true,
        getLocationCount: true,
        filterByAllBranch: this.model.filterByAllBranch,
        operator: 'AND'
      }
    };

    if (!this.customerContractData) {
      obj.queryJSON.rules.push({
        field: 'branchId',
        condition: '=',
        data: this.branch
      })
    }
    if (this.customerId) {
      obj.queryJSON.rules.push({
        field: 'customerId',
        condition: '=',
        data: this.customerId
      })
    }
    if (this.searchObj.text) {
      const searchFields = ['id', 'name', 'refNumber', 'keyNum', 'idOTCLock', 'address', 'city'];
      const trimmedSearchText = this.searchObj.text.trim();
      let searchWords = trimmedSearchText
        .split(/[^a-zA-Z0-9]+/)
        .filter((word) => /[a-zA-Z0-9]/.test(word));

      if (!searchWords.length && trimmedSearchText) {
        searchWords = [trimmedSearchText];
      }

      if (searchWords.length) {
        obj.queryJSON.rules.push({
          "group": {
            "operator": "AND",
            "rules": searchWords.map((word) => ({
              "group": {
                "operator": "OR",
                "rules": searchFields.map((field) => ({
                  "data": "%" + word + "%",
                  "field": field,
                  "condition": "like"
                }))
              }
            }))
          }
        });
      }
    }

    if (this.searchObj.type) {
      obj.queryJSON.rules.push({
        field: 'locationType',
        condition: '=',
        data: this.searchObj.type
      });
    }

    if (this.customerContractData && this.customerContractData.isRedirected) {
      obj.queryJSON.rules.push({
        field: 'customerId',
        condition: '=',
        data: this.customerContractData.customerId
      })
    }

    if (this.searchObj.status) {
      if (this.searchObj.status == 'active') {
        obj.queryJSON.rules.push({
          field: 'active',
          condition: '=',
          data: true
        });
      }
      else if (this.searchObj.status == 'inactive') {
        obj.queryJSON.rules.push({
          field: 'active',
          condition: '=',
          data: false
        });
      }
      else if (this.locationIds.length) {
        obj.queryJSON.rules.push({
          field: 'id',
          condition: 'IN',
          data: this.locationIds
        })
      }
    }

    return obj.queryJSON.rules.length ? obj : { branch: this.branch };

  }

  search() {
    this.page = 1;
    let newUrl = (window.location.pathname).replace('/' + this.$stateParams.page, '/' + this.page)
    this.$stateParams.page = this.page;
    this.$location.path(newUrl)

    if (this.searchObj.status == 'pending_changes') {
      this.getLocationIds();
    }
    else {
      this.locationIds = [];
      this.loadData();
    }
  }

  toggleExpand(location) {
    location.expand = !location.expand;
  }

  exportData() {
    let searchText = this.searchObj.text ? this.searchObj.text : null;
    let locationType = this.searchObj.type ? this.searchObj.type : null;
    let status = null;

    if (this.searchObj.status) {
      if (this.searchObj.status == 'active') status = true;
      else status = false;
    }

    this.isExporting = true;
    this.Service.exportLocations(searchText, locationType, status, this.branch, this.customerId, this.model.filterByAllBranch, this.loggedInUserId)
      .then((data) => {
        this.fileName = this.reportPrefix.concat('_', this.branch, '.csv');
        let a = document.createElement("a");
        document.body.appendChild(a);
        let file = new Blob([data.csvString], { type: 'application/csv' });
        let fileURL = window.URL.createObjectURL(file);
        a.href = fileURL;
        a.download = this.fileName;
        a.click();
      })
      .catch((err) => {
        console.log(err);
        if (err && err.data && err.data.message) {
          return this.Modal.errorModal(err.data.message)
        }
      })
      .finally(() => {
        this.isExporting = false;
      })
  }

  setPage(isExpanded, locationId) {
    if (!isExpanded) return;
    this.locationHistory[locationId] = { page: 1 }
  }

  getLocationUpdateHistory(isExpanded, locationId) {
    document.getElementById(`expand-btn-${locationId}`).blur();
    if (!isExpanded) return;

    this.locationHistory[locationId].process = true;

    this.Service.getLocationUpdateHistory(locationId, this.pagination.pageLimit, (this.locationHistory[locationId].page - 1) * this.pagination.pageLimit)
      .then((history) => this.getPendingLocationChanges(locationId).then(locationChanges => [history, locationChanges]))
      .then(([history, locationChanges]) => {
        this.locationUpdateHistory[locationId] = { details: history };
        this.pendingLocationChanges[locationId] = { details: locationChanges };
        this.locationUpdateHistory[locationId].details.results.forEach(log => {
          log.entryData = this.formatJson(log.entryData);
        })
        this.locationUpdateHistory[locationId].details.pageLimit = this.pagination.pageLimit;
      })
      .catch((err) => {
        console.log(err);
        if (err && err.data && err.data.message) {
          this.Modal.errorModal(err.data.message);
        }
      })
      .finally(() => {
        this.locationHistory[locationId].process = false;
      })
  }

  formatJson(obj) {
    if (_.isEmpty(obj)) return;
    return obj;
  }

  isArray(key) {
    return Array.isArray(key);
  }

  getPendingLocationChanges(locationId) {
    return this.Service.getPendingLocationChanges(locationId)
      .then((data) => {
        return data;
      })
  }

  translateMessage(key) {
    if (!key) return;
    return this.$translate.instant('location.' + key);
  }

  getLocationIds() {
    this.locationIds = [];
    this.Service.getPendingLocationChangesIds()
      .then((data) => {
        this.locationIds = data.results;
        this.loadData();
      })
      .catch((err) => {
        console.log(err);
        if (err && err.data && err.data.message) {
          this.Modal.errorModal(err.data.message);
        }
      })
  }

  resetRedirectionalData() {
    if (this.customerContractData) {
      this.customerContractData.isRedirected = false;
      this.customerContractData = this.DataCounter.setData();
    }
  }

  selectLocations(location, event) {
    setTimeout(() => {
      if (location.isSelected) {
        this.selectedLocations.push({
          locationId: location.id,
          locationName: location.name,
        })
      }
      else {
        let locIndex = _.findIndex(this.selectedLocations, { 'locationId': location.id });
        this.selectedLocations.splice(locIndex, 1);
      }
    });
  }

  printLocationBarcodes() {
    const obj = {
      selectedLocations: this.selectedLocations
    }

    const path = this.$state.href('printLocationBarcodes');
    window.w = window.open(path, '_blank');
    window.w.printData = obj;
  }

  updateLocationDrivingDistance() {
    this.model.updateDistance = true;
    this.Service.updateLocationDrivingDistance(this.model.filterByAllBranch, this.branch)
      .then(() => {
        this.Modal.confirm({
          header: this.$translate.instant('successModal.title'),
          message: 'Driving distance updated successfully.',
          callback: (({
            modal
          }) => {
            modal.close();
          }),
          type: 'success',
          buttons: ['common.ok']
        })
      })
      .catch((err) => {
        if (err && err.data && err.data.message) {
          this.Modal.errorModal(err.data.message);
        }
      })
      .finally(() => {
        this.model.updateDistance = false;
      })
  }

  bulkUpdateLocationDistance() {
    this.isBulkUpdateLocationDistance = true;
    this.Service.bulkUpdateLocationDistance(this.branch)
      .then(() => {
        this.Modal.confirm({
          header: this.$translate.instant('successModal.title'),
          message: 'Location distance updated successfully.',
          callback: (({
            modal
          }) => {
            modal.close();
          }),
          type: 'success',
          buttons: ['common.ok']
        })
      })
      .catch((err) => {
        if (err && err.data && err.data.message) {
          this.Modal.errorModal(err.data.message);
        }
      })
      .finally(() => {
        this.isBulkUpdateLocationDistance = false;
      })
  }

  isAllowToBulkUpdateLocationDistance() {
    const firstName = this.User.getUser().firstName;
    const lastName = this.User.getUser().lastName;
    const userId = this.User.getUser().id;
    return (firstName.toUpperCase() === 'COORWORKS' && lastName.toUpperCase() === 'ADMIN') || (firstName.toUpperCase() === 'ADMIN' && lastName.toUpperCase() === 'COORWORKS')
  }

}

export default LocationallController;



// WEBPACK FOOTER //
// ./client/app/components/location/all/location.all.controller.js